import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { usePurchaseOrderMainCommentEdit } from '@/features/purchase-order/hooks/use-purchase-order-main-comment-edit';
import { PurchaseOrderMainCommentForm } from '@/features/purchase-order/purchase-order-main-comment-form';
import type { PurchaseOrderComment } from '@/types/core/purchase-order/purchase-order-comment';

type PurchaseOrderMainCommentEditProps = {
  purchaseOrderId: string;
  comment: PurchaseOrderComment;
  open: boolean;
  setOpen: (value: boolean) => void;
};

export function PurchaseOrderMainCommentEdit({
  purchaseOrderId,
  comment,
  open,
  setOpen,
}: PurchaseOrderMainCommentEditProps) {
  const { t } = useTranslation('purchaseOrder');
  const { control, handleSubmit, onSubmit, isSubmitting } =
    usePurchaseOrderMainCommentEdit({ purchaseOrderId, comment, setOpen });

  const onOpenChange = (nextOpen: boolean) => {
    if (isSubmitting) {
      return;
    }
    setOpen(nextOpen);
  };

  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('Edit comment')}</DialogTitle>
          <DialogDescription />
        </DialogHeader>
        <PurchaseOrderMainCommentForm
          control={control}
          handleSubmit={handleSubmit}
          isSubmitting={isSubmitting}
          onSubmit={onSubmit}
        >
          <DialogClose asChild>
            <Button disabled={isSubmitting} type='button' variant='outline'>
              {t('cancel', { ns: 'common' })}
            </Button>
          </DialogClose>
        </PurchaseOrderMainCommentForm>
      </DialogContent>
    </Dialog>
  );
}
